import { render } from "./AlbumShareModal.vue?vue&type=template&id=4da264f4&scoped=true&ts=true"
import script from "./AlbumShareModal.vue?vue&type=script&lang=ts"
export * from "./AlbumShareModal.vue?vue&type=script&lang=ts"

import "./AlbumShareModal.vue?vue&type=style&index=0&id=4da264f4&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4da264f4"]])

export default __exports__